import React from "react";
import { Outlet } from "react-router-dom";

/** เลย์เอาต์หน้าสาธารณะ (ไม่ต้องล็อกอิน) เช่น /pay/:code */
export default function PublicLayout() {
  return (
    <div style={{ minHeight: "100vh", background: "var(--c-slate-50, #f8fafc)", display: "flex", justifyContent: "center", padding: "24px 12px" }}>
      <main style={{ width: "100%", maxWidth: 460 }}>
        <Outlet />
      </main>
    </div>
  );
}
